













































































































































































































































































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import moment from 'moment';
import SimService from '@/services/sim.service';
import Dialog from '@/components/Dialog.vue';
import {generateLuhnForIccid} from '@/helpers/luhn';
import SubscriptionsService from '@/services/subscriptions.service';
import {Organisation, SimProduct, SimRange, SimRangeResponse, SubscriptionPlan, SubscriptionPlanRequest, SubscriptionPlanType} from '@/types';
import SubscriptionPlanAddDrawer from '@/components/subscriptions/SubscriptionPlanAddDrawer.vue';
import BarcodeScanner from '@/components/BarcodeScanner.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import GenericButton from '@/components/GenericButton.vue';

@Component({
  components: {
    GenericButton,
    ConfirmButton,
    CancelButton,
    SubscriptionPlanAddDrawer,
    Dialog,
    BarcodeScanner,
  },
})
export default class SimStockManagement extends Vue {
  @Action private addToastErrorMessage: any;
  @Getter private hasPermission: any;
  @Getter private organisations: any;
  private showCreateSubscriptionPlan: boolean = false;
  private showSubscriptionDialog: boolean = false;
  private saveSubscriptionPlan: boolean = false;
  private selectedSubscriptionPlan: SubscriptionPlan | null = null;
  private importData: {[ key: string ]: any } = {};
  private batchData: {[ key: string ]: string } = {};
  private headers: Array<{[ key: string ]: string | boolean}> = [
    { text: 'Product code', value: 'sim_product.product_code', sortable: false, filterable: true },
    { text: 'Start', value: 'start_iccid', sortable: false, filterable: true },
    { text: 'End', value: 'end_iccid', sortable: false, filterable: true },
    { text: 'Created at', value: 'created_at_formatted', sortable: true, filterable: true },
    { text: 'Activate by', value: 'activate_by', sortable: false, filterable: false },
    { text: 'Count', value: 'count', sortable: false, filterable: false },
  ];
  private subscriptionPlans: SubscriptionPlan[] = [];
  private selectedOrg: string | null = null;
  private count: any = {};
  private simsToAllocate: Array<{[ key: string ]: string | number | boolean}> = [];
  private stock: Array<{[ key: string ]: string | number}> = [];
  private providers: Array<{[ key: string ]: string}> = [];
  private formFactors: Array<{[ key: string ]: string}> = [];
  private simTypes: Array<{ name: string, value: string }> = [
    { name: 'Standard', value: 'standard' },
    { name: 'Industrial', value: 'industrial' },
  ];
  private plan: SubscriptionPlanRequest = {} as SubscriptionPlanRequest;
  private planTypes: any[] = [];
  private products: SimProduct[] = [];
  private dataTableHeight: number = 100;
  private activateBy: string = '';
  private activateByMenu: boolean = false;
  private launchScanner: boolean = false;
  private scanTarget: string = '';
  private isAddingStock: boolean = false;
  private isLoadingStock: boolean = false;
  private isAllocating: boolean = false;
  private savingNewSubscriptionPlan: boolean = false;
  private sortBy: string = 'created_at';
  private search: string = '';

  private async mounted() {
    Promise.all([
      this.getStock(),
      this.getFormFactors(),
      this.getNetworkOperators(),
      this.getProducts(),
      this.getPlanTypes(),
    ]);
  }

  private get iccidBarcodeScannerEnabled() {
    return !!process.env.VUE_APP_FEATURE_ICCID_BARCODE_SCANNING;
  }

  private async addBatch() {
    this.isAddingStock = true;
    try {
      const form = (this.$refs.inputStockForm as any);
      if (form.validate()) {
        const payload = {
          start_iccid: this.importData.start_iccid,
          end_iccid: this.importData.end_iccid && this.importData.end_iccid.length ? this.importData.end_iccid : this.importData.start_iccid,
          sim_product_id: this.importData.product.id,
          activate_by: moment(this.activateBy).format(),
        };

        await SimService.createBatch(payload);

        Vue.set(this.importData, 'start_iccid', '');
        Vue.set(this.importData, 'end_iccid', '');
        Vue.set(this.importData, 'count', null);
        form.resetValidation();
        (this.$refs.startIccid as any).focus();
        this.getStock();

      }
    } finally {
      this.isAddingStock = false;
    }
  }

  private async getStock() {
    this.isLoadingStock = true;
    try {
      const stock = await SimService.getSimBatches();

      stock.forEach((s: SimRangeResponse) => {
        if (this.$options.filters) {
          (s as any).created_at_formatted = this.$options.filters.formatShortDate(s.created_at);
        }
      });
      Vue.set(this, 'stock', stock);
    } finally {
      this.isLoadingStock = false;
    }
  }

  private async getProducts() {
    const products = await SimService.getSimProducts();
    Vue.set(this, 'products', products);
  }

  private async getFormFactors() {
    const formFactors = await SimService.getFormFactors();
    Vue.set(this, 'formFactors', formFactors);
  }

  private async getNetworkOperators() {
    const providers = await SimService.getNetworkOperators();
    Vue.set(this, 'providers', providers);
  }

  private async getSubscriptionPlans() {
    this.selectedSubscriptionPlan = null;
    this.showCreateSubscriptionPlan = false;

    if (this.selectedOrg) {
      const plans = await SubscriptionsService.getSubscriptionPlansForSpecifiedOrganisation(this.selectedOrg, true);
      Vue.set(this, 'subscriptionPlans', plans);
    }
  }

  private setSelectedSubscriptionPlan(e: any) {
    this.getSubscriptionPlans();
    Vue.set(this, 'selectedSubscriptionPlan', e);
    this.simsToAllocate.push({ start_iccid: '', end_iccid: ''});
  }

  private populateExistingSubscriptionPlan() {
    if (this.selectedSubscriptionPlan) {
      this.selectedSubscriptionPlan.organisation = {} as Organisation;
      this.selectedSubscriptionPlan.organisation.id = Number(this.selectedOrg);
      this.simsToAllocate.push({ start_iccid: '', end_iccid: ''});
    }
  }

  private async allocateBatches(subscriptionPlanId: number) {
    this.isAllocating = true;
    const payload = {
      batches: this.simsToAllocate.map((batch) => {
        return {
          start_iccid: batch.start_iccid,
          end_iccid: batch.end_iccid,
        };
      }),
      subscription_plan_id: subscriptionPlanId,
    };
    await SimService.allocateBatches(payload);
    this.simsToAllocate = [];
    this.simsToAllocate.push({ start_iccid: '', end_iccid: ''});
    this.isAllocating = false;
    this.getStock();

  }

  private getIccidValues(row: any) {
    const iccids: any = {
      start_iccid: row.start_iccid,
      start_iccid_no_checksum: row.start_iccid.substring(0, row.start_iccid.length - 1),
      start_checksum: generateLuhnForIccid(row.start_iccid.substring(0, row.start_iccid.length - 1)),
      end_iccid: row.end_iccid,
      end_iccid_no_checksum: row.end_iccid.substring(0, row.end_iccid.length - 1),
      end_checksum: generateLuhnForIccid(row.end_iccid.substring(0, row.end_iccid.length - 1)),
      startCommon: row.start_iccid.substring(0, row.start_iccid.length - 6),
      startUnique: row.start_iccid.substring(row.start_iccid.length - 6, row.start_iccid.length - 1),
      endCommon: row.end_iccid.substring(0, row.end_iccid.length - 6),
      endUnique: row.end_iccid.substring(row.end_iccid.length - 6, row.end_iccid.length - 1),
    };
    row.count = this.rangeCount(iccids);
    this.batchData = row;
    return {...iccids, count: row.count};
  }

  private rangeCount(iccids: any) {
    const startUnique = iccids.start_iccid_no_checksum.substring(iccids.start_iccid_no_checksum.length - 6);
    const endUnique = iccids.end_iccid_no_checksum.substring(iccids.end_iccid_no_checksum.length - 6);
    this.count[iccids.start_iccid_no_checksum] = iccids.startCommon === iccids.endCommon ? (Number(endUnique) - Number(startUnique)) + 1 : 0;

    return iccids.startCommon === iccids.endCommon ? (Number(endUnique) - Number(startUnique)) + 1 : 0;
  }

  private closeCreateSubscription() {
    this.selectedSubscriptionPlan = null;
    this.selectedOrg = null;
    this.showSubscriptionDialog = false;
    this.showCreateSubscriptionPlan = false;
  }

  private removeFromAllocating(index: number) {
    this.simsToAllocate.splice(index, 1);
  }

  private updateDataTableHeight() {
    this.dataTableHeight = (this.$refs.stockCard as any).$el.clientHeight - 59;
  }

  private async getPlanTypes() {
    const types = await SubscriptionsService.getSubscriptionTypes(true);
    this.planTypes = types.map((t: SubscriptionPlanType) => {
      return {
        text: t.code,
        value: t.id,
        description: t.description,
        has_sims: t.has_sims,
      };
    });
  }

  private async handleCR(event: any, target: string, cb: (ref: any) => Promise<void> ) {
    if (!event || event.key !== 'Enter' || !target || !target.length || !cb) {
      return;
    }
    if (this.$refs[target]) {
      await cb(this.$refs[target]);
    }
  }

  private onBarcodeScan(result: any) {
    if (!result || !result.v1 || !this.scanTarget || !this.scanTarget.length) {
      return;
    }
    this.batchData[this.scanTarget] = result.v1;
  }

  private setActivateBy() {
    const activateBy = this.importData.product && this.importData.product.activation_period ?
        moment().add(this.importData.product.activation_period, 'd') :
        moment();

    if (!moment().isSame(activateBy, 'day')) {
      this.activateBy = activateBy.format('YYYY-MM-DD');
    } else {
      this.activateBy = moment().add(1, 'd').format('YYYY-MM-DD');
    }
  }

  private get tomorrow() {
    return moment().add(1, 'd').format('YYYY-MM-DD');
  }

  private filterProducts(item: SimProduct, queryText: string, itemText: string) {
    return (
      item.product_code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
      item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    );
  }
}
